// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root___H5Ya","disabled":"FileBtn_disabled__dK22v","warn":"FileBtn_warn__1usXg","fade":"FileBtn_fade__27yKl"};